/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from "react";

import useClickStats from "../../../hooks/clickstats";
import useLocalStorage from "../../../hooks/storage/localstorage";
import { ClickStatData } from "./interface";
import storeData from "./storeData";

export const StoreClickStatsKey = "daily-click-stats";

const StoreClickStats = (): null => {
  const [localValue, setLocalValue] =
    useLocalStorage<ClickStatData[]>(StoreClickStatsKey);
  const { clicks } = useClickStats();

  useEffect(() => {
    if (clicks) {
      storeData(localValue, setLocalValue, clicks);
    }
  }, [clicks]);

  return null;
};

export default StoreClickStats;
